export default __webpack_public_path__ + "static/media/1-2-4.7d275130.jpg";